<template lang="pug">

	b-modal(v-model="showModal" :hide-footer="true" :hide-header="false" title="Редактирование доклада" centered :id="`lectureModalEdit-${_lecture.id}`")

		// ALERTS
		Alerts(ref="Alerts")

		// FORM
		b-form(@submit.prevent='onSubmit')
			component(:is="field.widget" v-model="form[field.name]" v-for="field in htmlModelLecture" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

			div.g-between-center
				b-button.w-100(type='submit' variant='primary') Отправить

</template>

<script>
	import { mapState, mapActions } from 'vuex'

	import Alerts from '../Alerts'
	import collectFormData from '@/MIXINS/collectFormData';
	import formBackValidationMixin from '@/MIXINS/formBackValidation';

	import htmlModelLecture from '@/store/forms/formLecture'
	import modelSession from '../../../store/models/modelSession'


	export default {
		name: 'lectureModalEdit',
		props: ['_lecture'],
		components: {Alerts},
		mixins: [
			collectFormData,
			formBackValidationMixin,
		],
		data:()=>({
			showModal: false,
			okMsg: 'Доклад успешно изменен!',
			htmlModelLecture,
		}),
		computed: {
			...mapState(['myParticipant', 'account']),

			form(){
				const {title, description, attachment} = this._lecture;
				return {
					...modelSession,
					title,
					description,
					attachment,
					event: this.eventID,
					speaker_id: this.userID
				};
			},

			eventID() { return this.myParticipant.data.event.id || null },
			userID() { return this.account.data.id || null },
		},
		methods: {
			...mapActions(['patchSession']),
			...mapActions('myParticipant/nested/lectures', ['getPpntLectures']),

			hide() { this.showModal = false },

			errorHandler(error){
				error.non_field_errors
					? this.$refs.Alerts.showAlert(error.non_field_errors[0], 'error')
					: this.$refs.Alerts.showAlert(error.detail, 'error')
			},
			editSuccessHandler(){
				this.$refs.Alerts.showAlert(this.okMsg, 'success');
				this.$store.dispatch('getPpntLectures', { id:this.myParticipant.data.id });
				setTimeout( ()=>this.hide(), 500 );
			},
			onSubmit() {
				const data = {
					id: this._lecture.id,
					session: this.collectFormData(this.form)
				};
				if ( (typeof data.session.get('attachment')) === 'string'){
					delete data.session.delete('attachment');
				}
				this.$store.dispatch('patchSession', data)
					.then(this.editSuccessHandler)
					.catch(this.errorHandler)
			},
		},
	}
</script>

<style>
	.custom-file-input ~ .custom-file-label::after {
		content: 'Загрузить'!important;
	}
</style>
